import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../auth';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="p-8 text-tarot-muted">載入中…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  // RC-P2 — funnel un-onboarded users into /onboarding regardless of
  // which protected route they tried to land on. /onboarding itself is
  // the one exception (otherwise we'd infinite-redirect).
  if (!user.onboarding_complete && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }
  return <>{children}</>;
}
